import { BrokerRequest, DesiredContactTime, FormOfAddress,  } from "@/types";

export const normalizeContactFormValues = (values: BrokerRequest) => {
  const formOfAddress = Object.entries(FormOfAddress).find(
    (entry) => entry[1] === values.formOfAddress,
  )?.[0];

  const desiredContactTime = Object.entries(DesiredContactTime).find(
    (entry) => entry[1] === values.desiredContactTime,
  )?.[0];

  return { ...values, formOfAddress, desiredContactTime } as BrokerRequest;
};
